import { HTTP_AP_ListCases_ForClosedTable_Request_Filter, HTTP_AP_ListCases_ForClosedTable_Request_Sort } from '@api-new/caseservice';
import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { ClosedCaseTableRowModel } from '@platform/case/models/closed-case-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { AdjustedNetworkFilterModel } from '@shared/models/adjusted-network-filter.model';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const mortgageClosedCaseTableFilterDefaults: AdjustedNetworkFilterModel<HTTP_AP_ListCases_ForClosedTable_Request_Filter> = {
  createdAt: null,
  clientUserDisplayNameOrEmail: '',
  networkIds: [],
  companyIds: [],
  advisorUserDisplayNameOrEmail: '',
  caseType: null,
  updatedAt: null,
};

export const mortgageClosedCaseTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<ClosedCaseTableRowModel, HTTP_AP_ListCases_ForClosedTable_Request_Sort>[] => [
  {
    columnLabel: 'Client name',
    columnKey: 'clientUserDisplayName',
    sortKey: 'byClientUserDisplayName',
    type: RowDefinitionTypeEnum.FullnameShort,
    width: {
      min: '200px',
      max: '200px',
    },
    isFrozen: true,
  },
  {
    columnLabel: 'Case type',
    columnKey: 'caseTypeMapped',
    sortKey: 'byCaseType',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'Id',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Closing reason',
    columnKey: 'caseClosedReason',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'company',
    columnKey: 'companyTradingName',
    sortKey: 'byCompanyTradingName',
    type: RowDefinitionTypeEnum.Text,
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
      },
    ]),
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Adviser',
    columnKey: 'advisorUserDisplayName',
    sortKey: 'byAdvisorUserDisplayName',
    type: RowDefinitionTypeEnum.FullnameInitials,
    width: {
      min: '85px',
      max: '85px',
    },
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
      },
    ]),
  },
  {
    columnLabel: 'Created',
    columnKey: 'createdAt',
    sortKey: 'byCreatedAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Last updated',
    sortKey: 'byUpdatedAt',
    columnKey: 'updatedAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    width: {
      min: '100px',
      max: '100px',
    },
  },
];
